module.exports = __webpack_public_path__ + "static/media/guidance_1.e5e31595.png";